<script>
import Layout from '@layouts/loginLayout.vue'
import { requestPasswordReset } from '@src/api/auth'
import _ from 'lodash'

export default {
  page: {
    title: 'Request Password Change',
    meta: [
      {
        name: 'description',
        content: 'The Request Password Change page.',
      },
    ],
  },
  components: { Layout },
  data() {
    return {
      email: '',
      loading: false,
      successfully: false,
    }
  },
  computed: {
    placeholders() {
      return {
        email: 'Email',
      }
    },

    canPressButton() {
      if (!this.isValidEmail(this.email)) {
        return false
      }
      return !this.loading
    },
  },
  methods: {
    isValidEmail(email) {
      if (/^[_a-z0-9-]+(\.[_a-z0-9-]+)*(\+[a-z0-9-]+)?@[a-z0-9-]+(\.[a-z0-9-]+)*$/i.test(email)) {
        return true
      }
      return false
    },

    async resetPassword() {
      this.loading = true
      this.authError = null
      try {
        await requestPasswordReset({
          primaryEmail: this.email,
        }).then(() => {
          this.toastSuccess()
        })
      } catch (err) {
        this.authError = _.get(err, 'response.data.data.id', 'Server Error. Please try again in a few moments.')
        if (typeof this.authError === 'object') {
          this.authError = this.authError.join(' ')
        }
        this.toastError()
        this.loading = false
      }
    },

    toastError() {
      this.$bvToast.toast(this.authError, {
        toaster: 'b-toaster-bottom-center',
        toastClass: 'toast-error',
      })
    },

    toastSuccess() {
      const toastMessage = 'A password reset link has just been sent to both your Motto and personal email addresses.'
      this.$bvToast.toast(toastMessage, {
        toaster: 'b-toaster-bottom-center',
        toastClass: 'toast-success',
        noAutoHide: true,
      })
      this.loading = false
      this.successfully = true
    },
  },
}
</script>

<template>
  <Layout>
    <form @submit.prevent="resetPassword">
      <h1 class="motto-blue-text mb-55">Forgot My Password</h1>

      <div v-if="!successfully">
        <BaseFormGroup :label="placeholders.email" class="mb-40">
          <BaseInputText v-model="email" name="email" :placeholder="placeholders.email" />
        </BaseFormGroup>

        <BaseLink :to="{ name: 'login' }">Back to Login</BaseLink>

        <BaseButton :disabled="!canPressButton" type="submit">
          <BaseIcon v-if="loading" name="spinner" spin />
          <span v-else>Reset Password</span>
        </BaseButton>
      </div>
      <div v-else>
        <BaseLink :to="{ name: 'login' }">
          <BaseButton type="button">
            <span>Back to Login</span>
          </BaseButton>
        </BaseLink>
      </div>
    </form>
  </Layout>
</template>
